/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

/* eslint-disable no-duplicate-imports */
/* eslint-disable react/no-unknown-property */
// import * as Msdyn365 from '@msdyn365-commerce/core';
import { Module, Node, INodeProps, Modal } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { useState, useEffect } from 'react';
import { IImageListViewProps } from './moe-file-list';
import {
    FaLeanpub,
    FaGoogleDrive,
    FaDownload,
    FaFileWord,
    FaFileExcel,
    FaFilePdf,
    FaFilePowerpoint,
    FaFileImage,
    FaFile,
    FaFileCsv,
    FaFileCode,
    FaFileVideo,
    FaHtml5,
    FaFileInvoice,
    FaFileSignature,
    FaFileArchive,
    FaFileAudio
} from 'react-icons/fa';
import {
    BsFillFileEarmarkBarGraphFill,
    BsFileEarmarkRichtextFill,
    BsFileEarmarkPostFill,
    BsFileEarmarkFontFill,
    BsFileEarmarkCodeFill,
    BsFileEarmarkEaselFill
} from 'react-icons/bs';
import { RiFileGifFill } from 'react-icons/ri';
import { SiMicrosoftoutlook } from 'react-icons/si';
import { HiDocumentReport } from 'react-icons/hi';
import { getArtifactsByItemAsync } from '../../actions/extensions/DataActionExtension.g';
import MoeEpubViewerView from '../moe-epub-viewer/moe-epub-viewer.view';
import { IDictionary, IModule } from '@msdyn365-commerce/core-internal';
import { KWR, HEADER_FOOTER } from '../../utilities/constants';
import { getToggleLang, getUserPrefLang, getUserPreferredLanguage } from '../../utilities/language-change';
// eslint-disable-next-line prettier/prettier
// import { DocumentsDocumentType } from './moe-file-list.props.autogenerated';
// import { getArtifactsByItemAsync } from '../../actions/extensions/DataActionExtension.g';
// import { useEffect, useState } from 'react';
// import { IArtifacts } from '../../actions/extensions/DataServiceEntities.g';

/**
 * Render the thumbnail item images.
 * @param props - The image list view props.
 * @returns Return HTML having IImageListViewProps props with image List.
 */
export const imageListView = (props: IImageListViewProps): JSX.Element => {
    const { imageList, imageListContainer, imageListHeading, data, context, resources } = props;
    const [Artifacts, setArtifacts] = useState([]);
    const [previewModalOpen, setPreviewModalOpen] = useState(false);
    const [previewUrl, setPreviewUrl] = useState('');
    const [previewFileType, setPreviewFileType] = useState('EBOOKS');
    const [previewFileName, setPreviewFileName] = useState('');

    // Identifying Language Preference
    const toggleLang = getToggleLang(context);
    const userPrefLang = getUserPrefLang(context.request.user.customerAccountNumber as any, context);
    const preferredLanguage: any = getUserPreferredLanguage(KWR, HEADER_FOOTER, userPrefLang, toggleLang, context);

    const epubResources = {
        resourceKey: 'Resource key value'
    };

    const epubConfig = {
        ...props.config,
        epubUrl: previewUrl,
        title: previewFileName
    };

    const epubData = {
        actionResponse: { text: '' }
    };

    useEffect(() => {
        getArtifacts()?.then((artifacts: any) => {
            setArtifacts(artifacts);
        });
    }, [data?.product]);

    function getArtifacts() {
        try {
            const context: any = { callerContext: props.context.actionContext };
            console.log('Get Props inside get Artifacts');
            // return getArtifactsByItemAsync(context, 'NZH30').then(result => result);
            return getArtifactsByItemAsync(context, data?.product?.result?.ItemId as string).then((result: any) => {
                return result;
            });
        } catch (err) {
            console.log(err);
            return;
        }
    }

    const _showPreviewModal = (): INodeProps => {
        return {
            tag: Modal,
            placement: 'bottom-end',
            hideArrow: false,
            className: `msc-modal__dialog-success ${
                previewModalOpen ? 'moe-modal__filecontdialog-show' : 'moe-modal__filecontdialog-hide'
            }`,
            wrapClassName: '',
            isOpen: previewModalOpen
            // toggle: toggleShow
        };
    };

    // function getArtifactsByItemAsync(context: any, stringing: any): Promise<any[]> {
    //     return new Promise((resolve, reject) => {
    //         setTimeout(() => {
    //             return resolve([
    //                 {
    //                     ArtifactId: 'A015',
    //                     ItemId: 'NZH30',
    //                     MediaName: 'Learning Task 1 - Picture Dictation.doc',
    //                     MediaUrl: 'https://files-au-prod.cms.commerce.dynamics.com/cms/api/qsjhkgqqvf/binary/ML15DW',
    //                     Id: 5637146826,
    //                     ExtensionProperties: [
    //                         {
    //                             Key: 'FileType',
    //                             Value: {
    //                                 BooleanValue: null,
    //                                 IntegerValue: null,
    //                                 StringValue: 'DOC'
    //                             }
    //                         }
    //                     ]
    //                 }
    //             ]);
    //         }, 8000);
    //     });
    // }

    // File module state
    // const [isConfigCompleted, setIsConfigCompleted] = useState('pending');

    // console.log(isConfigCompleted);
    // console.log(config.configurationCompleted);

    // File module lifecycles
    // useEffect(() => {
    //     // Add CSP meta tag that will block cross-origin AJAX
    //     const cspMetaTag = document.createElement('meta');
    //     cspMetaTag.setAttribute('http-equiv', 'Content-Security-Policy');
    //     cspMetaTag.setAttribute(
    //         'content',
    //         "default-src * self blob: data: gap:; style-src * self 'unsafe-inline' blob: data: gap:; script-src * 'self' 'unsafe-eval' 'unsafe-inline' blob: data: gap:; object-src * 'self' blob: data: gap:; img-src * self 'unsafe-inline' blob: data: gap:; connect-src self * 'unsafe-inline' blob: data: gap:; frame-src * self blob: data: gap:;"
    //     );
    //     document.querySelector<any>('head').appendChild(cspMetaTag);
    // }, []);

    // useEffect(() => {
    //     if ((config.configurationCompleted as any) === 'complete') {
    //         // console.log('Inside fetch data');
    //         // void fetch('https://files-us-prod.cms.commerce.dynamics.com/cms/api/cczslpjdqt/binary/MA1AS7')
    //         //     .then((apiData: any) => console.log('API Data', apiData))
    //         //     .then(() => setIsConfigCompleted('complete'));
    //     } else {
    //         // console.log('Inside pending');
    //         setIsConfigCompleted('pending');
    //     }
    // }, [config.configurationCompleted]);
    function handlePreviewModalOpen(fileURL: any, fileType: string, name: string) {
        setPreviewModalOpen(true);
        setPreviewUrl(fileURL);
        setPreviewFileType(fileType);
        setPreviewFileName(name);
    }

    console.log('Artifacts', Artifacts);
    return !props.config.isCommonCatridge ? (
        <Module {...imageList}>
            {imageListHeading}
            <Node {...imageListContainer}>
                {Artifacts &&
                    Artifacts?.map((item: any, index: number): any => {
                        // let indexKey: string;

                        // if (item.image) {
                        //     const image = (item.image as unknown) as Msdyn365.Image;
                        //     indexKey = image.props.src as string;
                        // } else {
                        //     const text = (item.documentType as unknown) as Msdyn365.RichTextComponent;
                        //     indexKey = text.props.text as string;
                        // }
                        if (
                            item?.FileType?.toUpperCase() !== 'IMSCC' &&
                            item?.FileType?.toUpperCase() !== 'WEBPAGE' &&
                            !(item?.MediaName as string).includes('CogSearchIndexHelper') &&
                            !item?.IsRetire
                        ) {
                            return (
                                <li tabIndex={0} className='ms-moe-doc-list-item' key={index}>
                                    {renderDocument(item)}
                                </li>
                            );
                        }
                    })}
            </Node>
            <Node {..._showPreviewModal()}>
                <div tabIndex={0} className='modal-content'>
                    <div className='msc-modal__header'>
                        <h5 className='msc-modal__title' tabIndex={0}>
                            Ebook View
                        </h5>
                        <button
                            type='button'
                            onClick={() => setPreviewModalOpen(false)}
                            className='msc-modal__close-button'
                            aria-label='Close'
                        />
                    </div>
                    <div className='msc-modal__body'>
                        <div className='moe-file-preview__cont'>
                            {previewFileType === 'GSLIDES' && (
                                <iframe
                                    className='moe-vimeo-player__iframe'
                                    src={
                                        previewUrl ||
                                        'https://docs.google.com/presentation/d/e/2PACX-1vQsR5hStabJtOrkTPCjbbmJ-Ykcm91XloRe4o9AtOeOwTTvl-_3D2OuQ6-F7cXqrq91zkV1q4UAFLYu/embed?start=false&loop=false&delayms=30000'
                                    }
                                    frameBorder='0'
                                    allow='autoplay; fullscreen; picture-in-picture'
                                    title='36356c21-547d-48f8-83b1-025c3b4d_650.mp4'
                                ></iframe>
                            )}
                            {previewFileType === 'EBOOKS' && (
                                <>
                                    <MoeEpubViewerView
                                        config={epubConfig}
                                        resources={epubResources}
                                        app={{}}
                                        context={props.context}
                                        telemetry={props.telemetry}
                                        // eslint-disable-next-line react/jsx-no-bind
                                        renderModuleAttributes={function(props: unknown): IDictionary<string> {
                                            throw new Error('Function not implemented.');
                                        }}
                                        // eslint-disable-next-line react/jsx-no-bind
                                        renderView={function<
                                            T extends IModule<
                                                {},
                                                {
                                                    [/* eslint-disable no-duplicate-imports */
                                                    /* eslint-disable react/no-unknown-property */
                                                    // import * as Msdyn365 from '@msdyn365-commerce/core';
                                                    x: string]: any;
                                                }
                                            >
                                        >(props: T): React.ReactElement<any, string | React.JSXElementConstructor<any>> | null {
                                            throw new Error('Function not implemented.');
                                        }}
                                        data={epubData}
                                        dataActions={{}}
                                        friendlyName={''}
                                        id={''}
                                        typeName={''}
                                    />
                                </>
                            )}
                        </div>
                    </div>
                    <div className='msc-modal__footer'>
                        <a className='moe-btn moe-btn--primary-blue' download href={epubConfig.epubUrl} title={epubConfig.title}>
                            {preferredLanguage === 'maori' ? resources.downloadTextInMaori : resources.downloadText}
                        </a>
                    </div>
                </div>
            </Node>
        </Module>
    ) : (
        <div tabIndex={0} className='moe-common-catridge'>
            {props?.context?.request?.user?.isAuthenticated
                ? Artifacts &&
                  Artifacts?.map((item: any, index: number) => {
                      if (
                          item?.FileType?.toUpperCase() === 'IMSCC' &&
                          !(item?.MediaName as string).includes('CogSearchIndexHelper') &&
                          !item?.IsRetire &&
                          item?.LanguageId.toLowerCase() === context.request.locale.toLowerCase()
                      ) {
                          return (
                              <a
                                  key={index}
                                  download={'Common_catridge'}
                                  target='_blank'
                                  rel='noreferrer'
                                  className='moe-download-common-catridge tooltip-test'
                                  title={preferredLanguage === 'maori' ? resources.downloadLMSTextInMaori : resources.downloadLMSText}
                                  href={item.MediaUrl}
                                  aria-label={`Read More about ${item.MediaUrl}`}
                              >
                                  <FaDownload size={30} />{' '}
                                  <span>
                                      {preferredLanguage === 'maori' ? resources.downloadLMSTextInMaori : resources.downloadLMSText}
                                  </span>
                              </a>
                          );
                      } else {
                          return null;
                      }
                  })
                : null}
        </div>
    );

    // function renderWordFile(fileURL: any, MediaName: string) {
    //     return (
    //         <a
    //             target='_blank'
    //             download
    //             rel='noreferrer'
    //             className='tooltip-test'
    //             title={MediaName}
    //             href={fileURL}
    //             aria-label={`Read More about ${fileURL}`}
    //         >
    //             <FaFileWord size={30}></FaFileWord>
    //         </a>
    //     );
    // }

    // function renderExcelFile(fileURL: any, MediaName: string) {
    //     return (
    //         <a
    //             target='_blank'
    //             download
    //             rel='noreferrer'
    //             className='tooltip-test'
    //             title={MediaName}
    //             href={fileURL}
    //             aria-label={`Read More about ${fileURL}`}
    //         >
    //             <FaFileExcel size={30}></FaFileExcel>
    //         </a>
    //     );
    // }

    // function renderPPTFile(fileURL: any, MediaName: string) {
    //     return (
    //         <a
    //             target='_blank'
    //             download
    //             rel='noreferrer'
    //             className='tooltip-test'
    //             title={MediaName}
    //             href={fileURL}
    //             aria-label={`Read More about ${fileURL}`}
    //         >
    //             <FaFilePowerpoint size={30}></FaFilePowerpoint>
    //         </a>
    //     );
    // }

    // function renderPDFFile(fileURL: any, MediaName: string) {
    //     return (
    //         <a
    //             target='_blank'
    //             download
    //             rel='noreferrer'
    //             className='tooltip-test'
    //             title={MediaName}
    //             href={fileURL}
    //             aria-label={`Read More about ${fileURL}`}
    //         >
    //             <FaFilePdf size={30}></FaFilePdf>
    //         </a>
    //     );
    // }

    // function renderImageFile(fileURL: any, MediaName: string) {
    //     return (
    //         <a
    //             download
    //             target='_blank'
    //             rel='noreferrer'
    //             className='tooltip-test'
    //             title={MediaName}
    //             href={fileURL}
    //             aria-label={`Read More about ${fileURL}`}
    //         >
    //             <FaFileImage size={30} />
    //         </a>
    //     );
    // }

    // function renderGoogleDocFile(fileURL: any, MediaName: string) {
    //     return (
    //         <a
    //             download
    //             target='_blank'
    //             rel='noreferrer'
    //             className='tooltip-test'
    //             title={MediaName}
    //             href={fileURL}
    //             aria-label={`Read More about ${fileURL}`}
    //         >
    //             <FaGoogleDrive size={30} />
    //         </a>
    //     );
    // }

    // function renderAviFile(fileURL: any, MediaName: string) {
    //     return (
    //         <a
    //             download
    //             target='_blank'
    //             rel='noreferrer'
    //             className='tooltip-test'
    //             title={MediaName}
    //             href={fileURL}
    //             aria-label={`Read More about ${fileURL}`}
    //         >
    //             <FaFileVideo size={30} />
    //         </a>
    //     );
    // }

    // function renderBmpFile(fileURL: any, MediaName: string) {
    //     return (
    //         <a
    //             download
    //             target='_blank'
    //             rel='noreferrer'
    //             className='tooltip-test'
    //             title={MediaName}
    //             href={fileURL}
    //             aria-label={`Read More about ${fileURL}`}
    //         >
    //             <FaFileImage size={30} />
    //         </a>
    //     );
    // }

    // function renderCsvFile(fileURL: any, MediaName: string) {
    //     return (
    //         <a
    //             download
    //             target='_blank'
    //             rel='noreferrer'
    //             className='tooltip-test'
    //             title={MediaName}
    //             href={fileURL}
    //             aria-label={`Read More about ${fileURL}`}
    //         >
    //             <FaFileCsv size={30} />
    //         </a>
    //     );
    // }

    // function renderDocFile(fileURL: any, MediaName: string) {
    //     return (
    //         <a
    //             download
    //             target='_blank'
    //             rel='noreferrer'
    //             className='tooltip-test'
    //             title={MediaName}
    //             href={fileURL}
    //             aria-label={`Read More about ${fileURL}`}
    //         >
    //             <FaFileWord size={30} />
    //         </a>
    //     );
    // }

    // function renderGifFile(fileURL: any, MediaName: string) {
    //     return (
    //         <a
    //             download
    //             target='_blank'
    //             rel='noreferrer'
    //             className='tooltip-test'
    //             title={MediaName}
    //             href={fileURL}
    //             aria-label={`Read More about ${fileURL}`}
    //         >
    //             <RiFileGifFill size={30} />
    //         </a>
    //     );
    // }

    // function renderHTMLFile(fileURL: any, MediaName: string) {
    //     return (
    //         <a
    //             download
    //             target='_blank'
    //             rel='noreferrer'
    //             className='tooltip-test'
    //             title={MediaName}
    //             href={fileURL}
    //             aria-label={`Read More about ${fileURL}`}
    //         >
    //             <FaHtml5 size={30} />
    //         </a>
    //     );
    // }

    // function renderJSONFile(fileURL: any, MediaName: string) {
    //     return (
    //         <a
    //             download
    //             target='_blank'
    //             rel='noreferrer'
    //             className='tooltip-test'
    //             title={MediaName}
    //             href={fileURL}
    //             aria-label={`Read More about ${fileURL}`}
    //         >
    //             <FaFileInvoice size={30} />
    //         </a>
    //     );
    // }

    // function renderMhpFile(fileURL: any, MediaName: string) {
    //     return (
    //         <a
    //             download
    //             target='_blank'
    //             rel='noreferrer'
    //             className='tooltip-test'
    //             title={MediaName}
    //             href={fileURL}
    //             aria-label={`Read More about ${fileURL}`}
    //         >
    //             <BsFillFileEarmarkBarGraphFill size={30} />
    //         </a>
    //     );
    // }

    // function renderCodeFile(fileURL: any, MediaName: string) {
    //     return (
    //         <a
    //             download
    //             target='_blank'
    //             rel='noreferrer'
    //             className='tooltip-test'
    //             title={MediaName}
    //             href={fileURL}
    //             aria-label={`Read More about ${fileURL}`}
    //         >
    //             <FaFileCode size={30} />
    //         </a>
    //     );
    // }

    // function renderMsgFile(fileURL: any, MediaName: string) {
    //     return (
    //         <a
    //             download
    //             target='_blank'
    //             rel='noreferrer'
    //             className='tooltip-test'
    //             title={MediaName}
    //             href={fileURL}
    //             aria-label={`Read More about ${fileURL}`}
    //         >
    //             <SiMicrosoftoutlook size={30} />
    //         </a>
    //     );
    // }

    // function renderRTFFile(fileURL: any, MediaName: string) {
    //     return (
    //         <a
    //             download
    //             target='_blank'
    //             rel='noreferrer'
    //             className='tooltip-test'
    //             title={MediaName}
    //             href={fileURL}
    //             aria-label={`Read More about ${fileURL}`}
    //         >
    //             <BsFileEarmarkRichtextFill size={30} />
    //         </a>
    //     );
    // }

    // function renderSGMLFile(fileURL: any, MediaName: string) {
    //     return (
    //         <a
    //             download
    //             target='_blank'
    //             rel='noreferrer'
    //             className='tooltip-test'
    //             title={MediaName}
    //             href={fileURL}
    //             aria-label={`Read More about ${fileURL}`}
    //         >
    //             <BsFileEarmarkPostFill size={30} />
    //         </a>
    //     );
    // }

    // function renderTxtFile(fileURL: any, MediaName: string) {
    //     return (
    //         <a
    //             download
    //             target='_blank'
    //             rel='noreferrer'
    //             className='tooltip-test'
    //             title={MediaName}
    //             href={fileURL}
    //             aria-label={`Read More about ${fileURL}`}
    //         >
    //             <BsFileEarmarkFontFill size={30} />
    //         </a>
    //     );
    // }

    // function renderVsdFile(fileURL: any, MediaName: string) {
    //     return (
    //         <a
    //             download
    //             target='_blank'
    //             rel='noreferrer'
    //             className='tooltip-test'
    //             title={MediaName}
    //             href={fileURL}
    //             aria-label={`Read More about ${fileURL}`}
    //         >
    //             <FaFileSignature size={30} />
    //         </a>
    //     );
    // }

    // function renderXmlFile(fileURL: any, MediaName: string) {
    //     return (
    //         <a
    //             download
    //             target='_blank'
    //             rel='noreferrer'
    //             className='tooltip-test'
    //             title={MediaName}
    //             href={fileURL}
    //             aria-label={`Read More about ${fileURL}`}
    //         >
    //             <BsFileEarmarkCodeFill size={30} />
    //         </a>
    //     );
    // }

    // function renderZipFile(fileURL: any, MediaName: string) {
    //     return (
    //         <a
    //             download
    //             target='_blank'
    //             rel='noreferrer'
    //             className='tooltip-test'
    //             title={MediaName}
    //             href={fileURL}
    //             aria-label={`Read More about ${fileURL}`}
    //         >
    //             <FaFileArchive size={30} />
    //         </a>
    //     );
    // }

    // function renderotherFiles(fileURL: any, MediaName: string) {
    //     return (
    //         <a
    //             download
    //             target='_blank'
    //             rel='noreferrer'
    //             className='tooltip-test'
    //             title={MediaName}
    //             href={fileURL}
    //             aria-label={`Read More about ${fileURL}`}
    //         >
    //             <FaFile size={30} />
    //         </a>
    //     );
    // }

    // function renderGSlides(fileURL: any, MediaName: string) {
    //     return (
    //         <a
    //             target='_blank'
    //             download
    //             rel='noreferrer'
    //             className='tooltip-test'
    //             title={MediaName}
    //             // href={fileURL}
    //             onClick={() => handlePreviewModalOpen(fileURL, 'GSLIDES', MediaName)}
    //             aria-label={`Read More about ${fileURL}`}
    //         >
    //             <FaFilePowerpoint size={30}></FaFilePowerpoint>
    //         </a>
    //     );
    // }

    // function renderEbookPreview(fileURL: any, MediaName: string) {
    //     return (
    //         <a
    //             target='_blank'
    //             download
    //             rel='noreferrer'
    //             className='tooltip-test'
    //             title={MediaName}
    //             style={{ cursor: 'pointer' }}
    //             // href={fileURL}
    //             onClick={() => handlePreviewModalOpen(fileURL, 'EBOOKS', MediaName)}
    //             aria-label={`Read More about ${fileURL}`}
    //         >
    //             <FaLeanpub size={30}></FaLeanpub>
    //         </a>
    //     );
    // }

    // function renderAudioFile(fileURL: any, MediaName: string) {
    //     return (
    //         <a
    //             target='_blank'
    //             download
    //             rel='noreferrer'
    //             className='tooltip-test'
    //             title={MediaName}
    //             href={fileURL}
    //             aria-label={`Read More about ${fileURL}`}
    //         >
    //             <FaFileAudio size={30}></FaFileAudio>
    //         </a>
    //     );
    // }

    // function renderVideoFile(fileURL: any, MediaName: string) {
    //     return (
    //         <a
    //             target='_blank'
    //             download
    //             rel='noreferrer'
    //             className='tooltip-test'
    //             title={MediaName}
    //             href={fileURL}
    //             aria-label={`Read More about ${fileURL}`}
    //         >
    //             <FaFileVideo size={30}></FaFileVideo>
    //         </a>
    //     );
    // }

    // function renderPbixFile(fileURL: any, MediaName: string) {
    //     return (
    //         <a
    //             target='_blank'
    //             download
    //             rel='noreferrer'
    //             className='tooltip-test'
    //             title={MediaName}
    //             href={fileURL}
    //             aria-label={`Read More about ${fileURL}`}
    //         >
    //             <HiDocumentReport size={30}></HiDocumentReport>
    //         </a>
    //     );
    // }

    // function renderUsdzFile(fileURL: any, MediaName: string) {
    //     return (
    //         <a
    //             target='_blank'
    //             download
    //             rel='noreferrer'
    //             className='tooltip-test'
    //             title={MediaName}
    //             href={fileURL}
    //             aria-label={`Read More about ${fileURL}`}
    //         >
    //             <BsFileEarmarkEaselFill size={30}></BsFileEarmarkEaselFill>
    //         </a>
    //     );
    // }

    // function renderDaeFile(fileURL: any, MediaName: string) {
    //     return (
    //         <a
    //             target='_blank'
    //             download
    //             rel='noreferrer'
    //             className='tooltip-test'
    //             title={MediaName}
    //             href={fileURL}
    //             aria-label={`Read More about ${fileURL}`}
    //         >
    //             <BsFileEarmarkEaselFill size={30}></BsFileEarmarkEaselFill>
    //         </a>
    //     );
    // }

    // function renderXsnFile(fileURL: any, MediaName: string) {
    //     return (
    //         <a
    //             target='_blank'
    //             download
    //             rel='noreferrer'
    //             className='tooltip-test'
    //             title={MediaName}
    //             href={fileURL}
    //             aria-label={`Read More about ${fileURL}`}
    //         >
    //             <FaFileCode size={30}></FaFileCode>
    //         </a>
    //     );
    // }

    // function renderDocument(item: any) {
    //     return (
    //         <a
    //             download
    //             target='_blank'
    //             rel='noreferrer'
    //             className='tooltip-test'
    //             title={item.MediaName}
    //             href={item?.MediaUrl}
    //             aria-label={`Read More about ${item?.MediaUrl}`}
    //         >
    //             {renderDocumentIcon(item?.FileType.toUpperCase())}
    //         </a>
    //     );
    // }

    // function renderDocumentIcon(itemIconType: any) {
    //     if (itemIconType === 'DOC') {
    //         return <AiFillFileWord size={30}></AiFillFileWord>;
    //     } else if (itemIconType === 'IMAGE') {
    //         return <FaImage size={30} />;
    //     } else if (itemIconType === 'EXCEL') {
    //         return <AiFillFileExcel size={30}></AiFillFileExcel>;
    //     } else if (itemIconType === 'PPT') {
    //         return <AiFillFilePpt size={30}></AiFillFilePpt>;
    //     } else if (itemIconType === 'EPUB') {
    //         return <FaLeanpub size={30}></FaLeanpub>;
    //     } else if (itemIconType === 'PDF') {
    //         return <AiFillFilePdf size={30}></AiFillFilePdf>;
    //     } else if (itemIconType === 'GOOGLEDOC') {
    //         return <FaGoogleDrive size={30} />;
    //     } else {
    //         return null;
    //     }
    // }

    // function renderDocument(item: any) {
    //     if (item?.FileType?.toUpperCase() === 'DOC') {
    //         return renderWordFile(item.MediaUrl, item.MediaName);
    //     } else if (item?.FileType?.toUpperCase() === 'IMAGE') {
    //         return renderImageFile(item.MediaUrl, item.MediaName);
    //     } else if (item?.FileType?.toUpperCase() === 'EXCEL') {
    //         return renderExcelFile(item.MediaUrl, item.MediaName);
    //     } else if (item?.FileType?.toUpperCase() === 'PPT') {
    //         return renderPPTFile(item.MediaUrl, item.MediaName);
    //     } else if (item?.FileType?.toUpperCase() === 'PDF') {
    //         return renderPDFFile(item.MediaUrl, item.MediaName);
    //     } else if (item?.FileType?.toUpperCase() === 'GOOGLEDOC') {
    //         return renderGoogleDocFile(item.MediaUrl, item.MediaName);
    //     } else if (item?.FileType?.toUpperCase() === 'AVI') {
    //         return renderAviFile(item.MediaUrl, item.MediaName);
    //     } else if (item?.FileType?.toUpperCase() === 'BMP') {
    //         return renderBmpFile(item.MediaUrl, item.MediaName);
    //     } else if (item?.FileType?.toUpperCase() === 'CSV') {
    //         return renderCsvFile(item.MediaUrl, item.MediaName);
    //     } else if (item?.FileType?.toUpperCase() === 'DOC') {
    //         return renderDocFile(item.MediaUrl, item.MediaName);
    //     } else if (item?.FileType?.toUpperCase() === 'DOCX') {
    //         return renderDocFile(item.MediaUrl, item.MediaName);
    //     } else if (item?.FileType?.toUpperCase() === 'GIF') {
    //         return renderGifFile(item.MediaUrl, item.MediaName);
    //     } else if (item?.FileType?.toUpperCase() === 'HTM') {
    //         return renderHTMLFile(item.MediaUrl, item.MediaName);
    //     } else if (item?.FileType?.toUpperCase() === 'HTML') {
    //         return renderHTMLFile(item.MediaUrl, item.MediaName);
    //     } else if (item?.FileType?.toUpperCase() === 'JPEG') {
    //         return renderImageFile(item.MediaUrl, item.MediaName);
    //     } else if (item?.FileType?.toUpperCase() === 'JPG') {
    //         return renderImageFile(item.MediaUrl, item.MediaName);
    //     } else if (item?.FileType?.toUpperCase() === 'JSON') {
    //         return renderJSONFile(item.MediaUrl, item.MediaName);
    //     } else if (item?.FileType?.toUpperCase() === 'MHP') {
    //         return renderMhpFile(item.MediaUrl, item.MediaName);
    //     } else if (item?.FileType?.toUpperCase() === 'MHTML') {
    //         return renderCodeFile(item.MediaUrl, item.MediaName);
    //     } else if (item?.FileType?.toUpperCase() === 'MSG') {
    //         return renderMsgFile(item.MediaUrl, item.MediaName);
    //     } else if (item?.FileType?.toUpperCase() === 'PNG') {
    //         return renderImageFile(item.MediaUrl, item.MediaName);
    //     } else if (item?.FileType?.toUpperCase() === 'PPT') {
    //         return renderPPTFile(item.MediaUrl, item.MediaName);
    //     } else if (item?.FileType?.toUpperCase() === 'PPTX') {
    //         return renderPPTFile(item.MediaUrl, item.MediaName);
    //     } else if (item?.FileType?.toUpperCase() === 'RTF') {
    //         return renderRTFFile(item.MediaUrl, item.MediaName);
    //     } else if (item?.FileType?.toUpperCase() === 'SGML') {
    //         return renderSGMLFile(item.MediaUrl, item.MediaName);
    //     } else if (item?.FileType?.toUpperCase() === 'TIF') {
    //         return renderImageFile(item.MediaUrl, item.MediaName);
    //     } else if (item?.FileType?.toUpperCase() === 'TXT') {
    //         return renderTxtFile(item.MediaUrl, item.MediaName);
    //     } else if (item?.FileType?.toUpperCase() === 'VSD') {
    //         return renderVsdFile(item.MediaUrl, item.MediaName);
    //     } else if (item?.FileType?.toUpperCase() === 'WMF') {
    //         return renderImageFile(item.MediaUrl, item.MediaName);
    //     } else if (item?.FileType?.toUpperCase() === 'XHTML') {
    //         return renderCodeFile(item.MediaUrl, item.MediaName);
    //     } else if (item?.FileType?.toUpperCase() === 'XLS') {
    //         return renderExcelFile(item.MediaUrl, item.MediaName);
    //     } else if (item?.FileType?.toUpperCase() === 'XLSX') {
    //         return renderExcelFile(item.MediaUrl, item.MediaName);
    //     } else if (item?.FileType?.toUpperCase() === 'XML') {
    //         return renderXmlFile(item.MediaUrl, item.MediaName);
    //     } else if (item?.FileType?.toUpperCase() === 'ZIP') {
    //         return renderZipFile(item.MediaUrl, item.MediaName);
    //     } else if (item?.FileType?.toUpperCase() === 'GSLIDES') {
    //         return renderGSlides(item.MediaUrl, item.MediaName);
    //     } else if (item?.FileType?.toUpperCase() === 'EPUB') {
    //         return renderEbookPreview(item.MediaUrl, item.MediaName);
    //     } else if (item?.FileType?.toUpperCase() === 'WAV') {
    //         return renderAudioFile(item.MediaUrl, item.MediaName);
    //     } else if (item?.FileType?.toUpperCase() === 'MP3') {
    //         return renderAudioFile(item.MediaUrl, item.MediaName);
    //     } else if (item?.FileType?.toUpperCase() === 'WMA') {
    //         return renderAudioFile(item.MediaUrl, item.MediaName);
    //     } else if (item?.FileType?.toUpperCase() === 'MP4') {
    //         return renderVideoFile(item.MediaUrl, item.MediaName);
    //     } else if (item?.FileType?.toUpperCase() === 'MPEG') {
    //         return renderVideoFile(item.MediaUrl, item.MediaName);
    //     } else if (item?.FileType?.toUpperCase() === 'MOV') {
    //         return renderVideoFile(item.MediaUrl, item.MediaName);
    //     } else if (item?.FileType?.toUpperCase() === 'PIBX') {
    //         return renderPbixFile(item.MediaUrl, item.MediaName);
    //     } else if (item?.FileType?.toUpperCase() === 'USDZ') {
    //         return renderUsdzFile(item.MediaUrl, item.MediaName);
    //     } else if (item?.FileType?.toUpperCase() === 'DAE') {
    //         return renderDaeFile(item.MediaUrl, item.MediaName);
    //     } else if (item?.FileType?.toUpperCase() === 'XSN') {
    //         return renderXsnFile(item.MediaUrl, item.MediaName);
    //     } else {
    //         return renderotherFiles(item.MediaUrl, item.MediaName);
    //     }
    // }

    function getFileIcon(fileType: string) {
        if (fileType === 'DOC') {
            return <FaFileWord size={30}></FaFileWord>;
        } else if (fileType === 'IMAGE') {
            return <FaFileImage size={30} />;
        } else if (fileType === 'EXCEL') {
            return <FaFileExcel size={30}></FaFileExcel>;
        } else if (fileType === 'PPT') {
            return <FaFilePowerpoint size={30}></FaFilePowerpoint>;
        } else if (fileType === 'PDF') {
            return <FaFilePdf size={30}></FaFilePdf>;
        } else if (fileType === 'GOOGLEDOC') {
            return <FaGoogleDrive size={30} />;
        } else if (fileType === 'AVI') {
            return <FaFileVideo size={30} />;
        } else if (fileType === 'BMP') {
            return <FaFileImage size={30} />;
        } else if (fileType === 'CSV') {
            return <FaFileCsv size={30} />;
        } else if (fileType === 'DOC') {
            return <FaFileWord size={30} />;
        } else if (fileType === 'DOCX') {
            return <FaFileWord size={30} />;
        } else if (fileType === 'GIF') {
            return <RiFileGifFill size={30} />;
        } else if (fileType === 'HTM') {
            return <FaHtml5 size={30} />;
        } else if (fileType === 'HTML') {
            return <FaHtml5 size={30} />;
        } else if (fileType === 'JPEG') {
            return <FaFileImage size={30} />;
        } else if (fileType === 'JPG') {
            return <FaFileImage size={30} />;
        } else if (fileType === 'JSON') {
            return <FaFileInvoice size={30} />;
        } else if (fileType === 'MHP') {
            return <BsFillFileEarmarkBarGraphFill size={30} />;
        } else if (fileType === 'MHTML') {
            return <FaFileCode size={30} />;
        } else if (fileType === 'MSG') {
            return <SiMicrosoftoutlook size={30} />;
        } else if (fileType === 'PNG') {
            return <FaFileImage size={30} />;
        } else if (fileType === 'PPT') {
            return <FaFilePowerpoint size={30}></FaFilePowerpoint>;
        } else if (fileType === 'PPTX') {
            return <FaFilePowerpoint size={30}></FaFilePowerpoint>;
        } else if (fileType === 'RTF') {
            return <BsFileEarmarkRichtextFill size={30} />;
        } else if (fileType === 'SGML') {
            return <BsFileEarmarkPostFill size={30} />;
        } else if (fileType === 'TIF') {
            return <FaFileImage size={30} />;
        } else if (fileType === 'TXT') {
            return <BsFileEarmarkFontFill size={30} />;
        } else if (fileType === 'VSD') {
            return <FaFileSignature size={30} />;
        } else if (fileType === 'WMF') {
            return <FaFileImage size={30} />;
        } else if (fileType === 'XHTML') {
            return <FaFileCode size={30} />;
        } else if (fileType === 'XLS') {
            return <FaFileExcel size={30}></FaFileExcel>;
        } else if (fileType === 'XLSX') {
            return <FaFileExcel size={30}></FaFileExcel>;
        } else if (fileType === 'XML') {
            return <BsFileEarmarkCodeFill size={30} />;
        } else if (fileType === 'ZIP') {
            return <FaFileArchive size={30} />;
        } else if (fileType === 'GSLIDES') {
            return <FaFilePowerpoint size={30}></FaFilePowerpoint>;
        } else if (fileType === 'EPUB') {
            return <FaLeanpub size={30}></FaLeanpub>;
        } else if (fileType === 'WAV') {
            return <FaFileAudio size={30}></FaFileAudio>;
        } else if (fileType === 'MP3') {
            return <FaFileAudio size={30}></FaFileAudio>;
        } else if (fileType === 'WMA') {
            return <FaFileAudio size={30}></FaFileAudio>;
        } else if (fileType === 'MP4') {
            return <FaFileVideo size={30}></FaFileVideo>;
        } else if (fileType === 'MPEG') {
            return <FaFileVideo size={30}></FaFileVideo>;
        } else if (fileType === 'MOV') {
            return <FaFileVideo size={30}></FaFileVideo>;
        } else if (fileType === 'PIBX') {
            return <HiDocumentReport size={30}></HiDocumentReport>;
        } else if (fileType === 'USDZ') {
            return <BsFileEarmarkEaselFill size={30}></BsFileEarmarkEaselFill>;
        } else if (fileType === 'DAE') {
            return <BsFileEarmarkEaselFill size={30}></BsFileEarmarkEaselFill>;
        } else if (fileType === 'XSN') {
            return <FaFileCode size={30}></FaFileCode>;
        } else {
            return <FaFile size={30} />;
        }
    }

    function renderDocument(item: any) {
        const { MediaName, MediaUrl } = item;
        const fileType = item?.FileType?.toUpperCase();

        if (fileType === 'EPUB' || fileType === 'GSLIDES') {
            const previewMode = fileType === 'EPUB' ? 'EBOOKS' : 'GSLIDES';
            return (
                <a
                    target='_blank'
                    download
                    rel='noreferrer'
                    className='tooltip-test'
                    title={`${MediaName} (${item?.FileType} ${item.FileSize})`.replace(/  +/g, ' ')}
                    href={MediaUrl}
                    aria-label={`Read More about ${MediaName}`}
                    onClick={() => handlePreviewModalOpen(MediaUrl, previewMode, MediaName)}
                >
                    {getFileIcon(fileType)}
                </a>
            );
        }
        return (
            <a
                target='_blank'
                download
                rel='noreferrer'
                className='tooltip-test'
                title={`${MediaName} (${item?.FileType} ${item.FileSize})`.replace(/  +/g, ' ')}
                href={MediaUrl}
                aria-label={`Read More about ${MediaName}`}
            >
                {getFileIcon(fileType)}
            </a>
        );
    }
};

export default imageListView;
